export const gaTopbarHeight = 56;
export const documentViewFloatingTopbarHeight = 56;
